export const shouldUseDefaultTitle = (title, totalSteps, isEditMode) => !title && totalSteps === 1 && !isEditMode;
